import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-homepage-three",
    templateUrl: "./homepage-three.component.html",
    styleUrls: ["./homepage-three.component.scss"],
})
export class HomepageThreeComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
